import axios from 'axios';

export async function fetchPictogramLayerStatuses(layerId, params = {}) {
  const url = `/api/v2/pictogram-layer/${layerId}/statuses`;
  return axios.get(url, { params: params });
}
